<template>
    <v-layout row
              wrap>
        <v-flex xs12>
            <crud resource="deliveries"
                  :manager="manager"
                  :custom-view-dialog="true"
                  :filters="filters"
                  :creatable="false"
                  ref="crud"
                  :extra-overflow-actions="extraOverflowActions"
            />
        </v-flex>
      <!--View Dialog - Custom View-->
      <v-dialog v-model="viewDialogHere" max-width="1000px">
        <v-card v-if="item">
          <v-card-text>
            <connection-manager ref="connectionManager"
                                v-model="connecting"/>
            <v-data-table
              hide-headers
              hide-actions
              :headers="viewItemHeaders"
              :items="viewableHeaders">
              <template slot="items"
                        slot-scope="props">
                <td>{{props.item.text}}</td>
                <td>{{manager.toValue(props.item, item)}}</td>
              </template>
            </v-data-table>
            <v-data-table
              :items="item.items"
              hide-actions
              item-key="id"
              :style="'max-height: '+($vuetify.breakpoint.height * 0.30)+'px;'"
              class="scroll-y"
              :headers="itemHeaders">
              <template slot="items" slot-scope="props">
                <td>{{props.item.courierOption.name}}</td>
                <td>{{props.item.destinationName}}</td>
                <td>{{props.item.recipientName}}</td>
                <td>{{props.item.recipientContact}}</td>
                <td>{{props.item.quantity}}</td>
                <td>{{props.item.status}}</td>
                <td>{{props.item.receivedTime ? props.item.receivedTime : defaultValue}}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="red darken-1"
                   flat
                   :disabled="connecting"
                   @click.native="close">
              Close
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="proceedWithCancel"
        max-width="400"
      >
        <v-card>
          <v-card-title class="headline">Do you want to cancel this delivery?</v-card-title>
          <v-card-text>
            The action can't be reversed and the client will be charged
          </v-card-text>

          <v-card-text>
            <v-flex xs12 sm12 md12>
              <v-textarea
                solo
                name="input-7-4"
                label="Reason"
                v-model="cancellationReason"
              ></v-textarea>
            </v-flex>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click="proceedWithCancel = false"
            >
              Go Back
            </v-btn>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="cancelDelivery()"
            >
              Proceed
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="changeUrgency"
        max-width="400"
      >
        <v-card>
          <v-card-title class="headline">Do you want to change the urgency?</v-card-title>
          <v-card-text>
            Changing the urgency will affect the cost of the delivery
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click="changeUrgency = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="changeDeliveryUrgency()"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
</template>

<script>
  import Crud from './Crud'
  import CrudBase from './CrudBase.vue'
  import ConnectionManager from './ConnectionManager'

  export default {
    name: 'Deliveries',
    extends: CrudBase,
    components: {ConnectionManager, Crud},
    data () {
      return {
        item: null,
        currentItem: null,
        connecting: false,
        proceedWithCancel: false,
        viewDialogHere: false,
        changeUrgency: false,
        cancellationReason: '',
        viewableHeaders: [],
        viewItemHeaders: [],
        itemHeaders: [
          {text: 'Name', value: 'product.name'},
          {text: 'Destination', value: 'item.destinationName'},
          {text: 'Recipient Name', value: 'item.recipientName'},
          {text: 'Recipient Contact', value: 'item.recipientContact'},
          {text: 'Quantity', value: 'item.quantity'},
          {text: 'Status', value: 'item.status'},
          {text: 'Received Time', value: 'item.receivedTime'}
        ],
        extraOverflowActions: [
          {
            name: 'Cancel',
            key: 'cancel'
          }, {
            name: 'Change Urgency',
            key: 'change_urgency'
          }
        ],
        filters: [
          {value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head'},
          {value: 'AT_PURCHASING_HEAD', name: 'At purchasing Head'},
          {value: 'REJECTED', name: 'Rejected'},
          {value: 'PENDING_DELIVERY', name: 'Pending Pickup'},
          {value: 'BEING_DELIVERED', name: 'In Progress'},
          {value: 'DELIVERED', name: 'Delivered'}
        ]
      }
    },
    methods: {
      close () {
        this.item = null
        this.viewDialogHere = false
      },
      cancelDelivery () {
        this.proceedWithCancel = false
        let that = this
        this.$refs.crud.$refs.connectionManager.patch('deliveries/' + this.item.id, {
          onSuccess (response) {
            // that.items = []
            // that.items = that.items.concat(response.data.data)
            // that.$refs.crud.initialize()
            that.$refs.crud.updateItem(that.item)
          }
        }, {
          action: 'cancel',
          reason: that.cancellationReason
        })
      },
      changeDeliveryUrgency () {
        this.changeUrgency = false
        let that = this
        this.$refs.crud.$refs.connectionManager.patch('deliveries/' + this.item.id, {
          onSuccess (response) {
            // that.items = []
            // that.items = that.items.concat(response.data.data)
            that.$refs.crud.updateItem(response.data.data)
          }
        }, {
          action: 'change_urgency'
        })
      },
      initialize () {
        let that = this
        this.manager.editable = (item) => {
          return this.isAdmin()
        }
        this.manager.deletable = (item) => {
          return false
        }
        this.manager.creatable = () => {
          return false
        }
        this.manager.toValue = (header, item) => {
          if (header.value === 'from') {
            return item.originFormattedAddress ? item.originFormattedAddress : that.defaultValue
          }
          if (header.value === 'client') {
            return item.user && item.user.client ? item.user.client.name : that.defaultValue
          }
          if (header.value === 'riderId') {
            return item.rider ? item.rider.name : that.defaultValue
          }
          if (header.value === 'date') {
            return item.scheduleDate ? item.scheduleDate : that.defaultValue
          }
          if (header.value === 'time') {
            return item.scheduleTime ? item.scheduleTime : that.defaultValue
          }
          if (header.value === 'riderName') {
            return item.rider ? item.rider.name : that.defaultValue
          }
          if (header.value === 'placedBy') {
            return item.user ? item.user.name + ' - ' + item.user.phone : that.defaultValue
          }
          if (header.value === 'estimatedCost') {
            return item.estimatedCost ? that.$app.formatMoney(item.estimatedCost) : that.defaultValue
          }
          if (header.value === 'urgent') {
            return item.urgent ? 'Urgent' : 'Not Urgent'
          }
          if (header.value === 'riderPhone') {
            return item.rider ? item.rider.phone : that.defaultValue
          } else {
            return item[header.value] ? item[header.value] : that.defaultValue
          }
        }
        this.manager.nameOnDelete = (item) => {
          return 'this order.'
        }
        this.manager.hasCustomView = (item, viewableHeaders, viewItemHeaders) => {
          that.item = item
          that.viewDialogHere = false
          that.viewDialogHere = true
          that.viewableHeaders = viewableHeaders
          that.viewItemHeaders = viewItemHeaders
          return true
        }
        this.manager.showInlineAction = (action, item, filter) => {
          if (action.key === 'dispatch' && filter) {
            return filter.value === 'PENDING_DISPATCH' && (this.isAdmin() || this.isOperations())
          }
          if (action.key === 'confirmReceived' && filter) {
            return filter.value === 'DISPATCHED' && this.isDepartmentUser()
          } else {
            return true
          }
        }
        this.manager.showTopAction = (action, items, filter) => {
          if ((action.key === 'approveAll' || action.key === 'rejectAll') && filter) {
            return ((filter.value === 'AT_DEPARTMENT_HEAD' && this.isDepartmentHead()) ||
              (filter.value === 'AT_PURCHASING_HEAD' && this.isPurchasingHead())) && items.length
          } else {
            return true
          }
        }
        this.manager.onTopAction = (action, items, filter) => {
          if (action.key === 'approveAll' || action.key === 'rejectAll') {
            this.$refs.connectionManager.patch('orders/' + action, {
              onSuccess (response) {
                that.$refs.crud.clearItems()
              }
            })
          }
        }
        this.manager.onInlineActionClicked = (action, item, filter) => {
          if (action.key === 'view') {
            that.$refs.crud.viewItem(item)
          } else if (action.key === 'dispatch') {
            that.viewableHeaders = that.$refs.crud.viewableHeaders
            that.viewItemHeaders = that.$refs.crud.viewItemHeaders
            that.dispatchingItem = item
            that.dispatching = true
          } else if (action.key === 'confirmReceived') {
            that.viewableHeaders = that.$refs.crud.viewableHeaders
            that.viewItemHeaders = that.$refs.crud.viewItemHeaders
            that.confirmingReceivedItem = item
            that.confirmingReceived = true
          }
        }
        this.manager.showExtraOverflowActions = (action, filter) => {
          if (action.key === 'cancel') {
            return filter.value === 'PENDING_DELIVERY' || filter.value === 'BEING_DELIVERED'
          } else {
            return true
          }
        }
        this.manager.hideHeader = (header, filter) => {
          if (header.value === 'rejectedBy') {
            return filter.value === 'REJECTED'
          } else if (header.value === 'dispatchedAt') {
            return filter.value !== 'DISPATCHED' || that.isSupplier()
          } else if (header.value === 'dispatchedBy') {
            return filter.value !== 'DISPATCHED' || !that.isSupplier()
          } else if (header.value === 'receivedConfirmedAt') {
            return filter.value !== 'DELIVERED'
          } else if (header.value === 'receivedConfirmedBy') {
            return filter.value !== 'DELIVERED'
          } else if (header.value === 'dispatchRider') {
            return filter.value !== 'DISPATCHED'
          } else if (header.value === 'itemsReceivedFromSupplierCount') {
            return !that.isAdmin() && !that.isOperations()
          } else if (header.value === 'itemsNotReceivedFromSupplierCount') {
            return !that.isAdmin() && !that.isOperations()
          } else if (header.value === 'client') {
            return !that.isAdmin() && !that.isOperations()
          } else {
            return false
          }
        }
        this.manager.fireAction = (action, item) => {
          that.item = item
          if (action.key === 'change_urgency') {
            that.changeUrgency = true
          } else if (action.key === 'cancel') {
            that.proceedWithCancel = true
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Deliveries.vue